/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Next_LabelInputs */



/**
* | output |
* | --- |
* | "Next 1:1" |
*
* @param {Team_Next_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_next_label = /** @type {((inputs?: Team_Next_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Next_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Volgende 1:1")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prochain one-to-one")
	return /** @type {LocalizedString} */ ("Next 1:1")
});